class WinePortfolioHero extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-wine-card]'));

    if (this.cards.length <= 3) return;

    this.pickFeaturedCards();
  }

  pickFeaturedCards() {
    const now = Date.now();
    const total = this.cards.length;

    const rankedCards = this.cards
      .filter((card, index, cards) => cards.findIndex((candidate) => candidate.href === card.href) === index)
      .map((card) => {
        const index = Number(card.dataset.index || 1);
        const publishedAt = Number(card.dataset.publishedAt || 0) * 1000;
        const isNewestPool = card.dataset.source === 'new';
        const isPopularPool = card.dataset.source === 'popular';
        const ageInDays = publishedAt > 0 ? Math.max(0, (now - publishedAt) / 86400000) : 365;
        const collectionOrderScore = isPopularPool ? ((total - index + 1) / total) * 30 : 8;
        const freshnessScore = isNewestPool ? Math.max(0, 50 - ageInDays / 4) : Math.max(0, 25 - ageInDays / 8);
        const randomnessScore = Math.random() * 32;

        return {
          card,
          score: collectionOrderScore + freshnessScore + randomnessScore,
        };
      })
      .sort((a, b) => b.score - a.score)
      .slice(0, 3);

    this.cards.forEach((card) => card.classList.remove('is-active'));

    rankedCards
      .sort(() => Math.random() - 0.5)
      .forEach(({ card }) => {
        card.classList.add('is-active');
        this.append(card);
      });
  }
}

if (!customElements.get('wine-portfolio-hero')) {
  customElements.define('wine-portfolio-hero', WinePortfolioHero);
}
